<section
	#timePicker
	[id]="id"
	[class]="'agpr-timePicker ' + styleClass"
>
	<div
		#container
		class="agpr-timePicker-time"
	>
	    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
		<div
			class="agpr-timePicker-input"
			[ngClass]="{'agpr-timePicker-inputActive': panelVisible,
						'agpr-timePicker-input--disabled': disabled}"
			(click)="inputClick($event)"
		>
			<span
				class="agpr-timePicker-icon fa-regular fa-clock"
			></span>
			<fieldset
				class="agpr-timePicker-fieldset"
				(focusin)="onFocus()"
				(focusout)="onFocusOut($event)"
			>
				<legend [ngClass]="{ 'u-srOnly': isHiddenLabel }">
					{{ header || localization.selectTime }}
				</legend>
				<input #hourInput
					*ngIf="value && showHour"
					autocomplete="off"
					type="text"
					placeholder="--"
					class="agpr-timePicker-input-field"
					[id]="id + '.timePicker.hourInput'"
					[attr.aria-describedby]="hourDescribedBy"
					[disabled]="disabled"
					[ngModel]="value.hour | addLeadingZero"
					(wheel)="scrollHour($event)"
					(focus)="setActiveTimeUnit(timeUnits.hours)"
					(keydown)="inputKeydown($event, hourInput)"
					[attr.aria-label]="localization.selectHour"
					role="spinbutton"
					[attr.aria-valuenow]="value.hour"
					[attr.aria-valuemin]="1"
					[attr.aria-valuemax]="maxHour"
					[attr.required]="required ? required : null"
				/>
				<span
					*ngIf="showHour"
					aria-hidden="true"
				>:</span>
				<input
					*ngIf="value"
					#minuteInput
					autocomplete="off"
					type="text"
					placeholder="--"
					[id]="id + '.timePicker.minuteInput'"
					[attr.aria-describedby]="minuteDescribedBy"
					[disabled]="disabled"
					[ngModel]="value.minute | addLeadingZero"
					class="agpr-timePicker-input-field"
					(wheel)="scrollMinute($event)"
					(focus)="setActiveTimeUnit(timeUnits.minutes)"
					(keydown)="inputKeydown($event, minuteInput)"
					[attr.aria-label]="localization.selectMinute"
					role="spinbutton"
					[attr.aria-valuenow]="value.minute"
					[attr.aria-valuemin]="0"
					[attr.aria-valuemax]="59"
					[attr.required]="required ? required : null"
				/>
				<span *ngIf="showSecond"
					aria-hidden="true"
				>:</span>
				<input #secondInput
					*ngIf="value && showSecond"
					autocomplete="off"
					type="text"
					placeholder="--"
					[id]="id + '.timePicker.secondInput'"
					[attr.aria-describedby]="secondDescribedBy"
					[disabled]="disabled"
					[ngModel]="value.second | addLeadingZero"
					class="agpr-timePicker-input-field"
					(wheel)="scrollSecond($event)"
					(focus)="setActiveTimeUnit(timeUnits.seconds)"
					(keydown)="inputKeydown($event, secondInput)"
					[attr.aria-label]="localization.selectSecond"
					role="spinbutton"
					[attr.aria-valuenow]="value.second"
					[attr.aria-valuemin]="0"
					[attr.aria-valuemax]="59"
					[attr.required]="required ? required : null"
				/>
				<input #meridianInput
					*ngIf="value && value.format === timeFormats.twelveHour && !durationMode"
					readonly
					autocomplete="off"
					class="agpr-timePicker-input-field meridianInput"
					type="text"
					[id]="id + '.timePicker.meridianInput'"
					[disabled]="disabled"
					[ngModel]="value.meridian"
					(ngModelChange)="meridianChanged($event)"
					(keydown)="inputKeydown($event, meridianInput)"
					(focus)="setActiveTimeUnit(null)"
					[attr.aria-label]="localization.selectMeridian"
					[attr.required]="required ? required : null"
				/>
			</fieldset>
		</div>
		<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
	</div>
	<div
		#panel
		class="agpr-timePicker-time-panel agpr-clickOutsideExcluded"
		[id]="id + '.timePanel'"
		[@panelState]="panelVisible ? 'visible' : 'hidden'"
		[style.display]="panelVisible ? 'flex' : 'none'"
		(click)="panelClick($event)"
	>
		<fieldset class="agpr-timePicker-time-panel-fieldset">
			<legend class="agpr-timePicker-time-panel-legend u-srOnly">{{ localization.selectTime }}</legend>
			<label class="agpr-timePicker-time-panel-input" *ngIf="showHour">
				<span class="u-srOnly">
					{{ localization.selectHour | addLeadingZero }}
				</span>
				<span
					class="fa-solid fa-angle-up agpr-timePicker-time-panel-icon"
					[class.agpr-timePicker-time-panel-icon--disabled]="isIncrementDisabled(timeUnits.hours)"
					[attr.aria-disabled]="isIncrementDisabled(timeUnits.hours)"
					(click)="increment(timeUnits.hours)"
				></span>
				<div class="agpr-timePicker-time-panel-value" [ngClass]="{'activeUnit': activeTimeUnit === timeUnits.hours}">
					<input
						*ngIf="value && showHour"
						autocomplete="off"
						readonly
						type="text"
						placeholder="--"
						[id]="id + '.timePicker.panel.hourInput'"
						[attr.aria-describedby]="hourDescribedBy"
						[disabled]="disabled"
						[ngModel]="value.hour | addLeadingZero"
						(wheel)="scrollHour($event)"
						(focus)="setActiveTimeUnit(timeUnits.hours)"
						(keydown)="inputKeydown($event, hourInput)"
						role="spinbutton"
						[attr.aria-valuemin]="0"
						[attr.aria-valuemax]="maxHour"
						[attr.aria-valuenow]="value.hour | addLeadingZero"
						[attr.aria-label]="localization.selectHour"
					/>
				</div>
				<span
					class="fa-solid fa-angle-down agpr-timePicker-time-panel-icon"
					[class.agpr-timePicker-time-panel-icon--disabled]="isDecrementDisabled(timeUnits.hours)"
					[attr.aria-disabled]="isDecrementDisabled(timeUnits.hours)"
					(click)="decrement(timeUnits.hours)"
				></span>
			</label>
			<div
				aria-hidden="true"
				class="agpr-timePicker-numberInputSeparator"
				*ngIf="showHour">
				:
			</div>
			<label class="agpr-timePicker-time-panel-input">
				<span class="u-srOnly">
					{{ localization.selectMinute }}
				</span>
				<span
					class="fa-solid fa-angle-up agpr-timePicker-time-panel-icon"
					[class.agpr-timePicker-time-panel-icon--disabled]="isIncrementDisabled(timeUnits.minutes)"
					[attr.aria-disabled]="isIncrementDisabled(timeUnits.minutes)"
					(click)="increment(timeUnits.minutes)"
				></span>
				<div class="agpr-timePicker-time-panel-value" [ngClass]="{'activeUnit': activeTimeUnit === timeUnits.minutes}">
					<input
						*ngIf="value"
						autocomplete="off"
						readonly
						type="text"
						placeholder="--"
						[id]="id + '.timePicker.panel.minuteInput'"
						[attr.aria-describedby]="minuteDescribedBy"
						[disabled]="disabled"
						[ngModel]="value.minute | addLeadingZero"
						(wheel)="scrollMinute($event)"
						(focus)="setActiveTimeUnit(timeUnits.minutes)"
						(keydown)="inputKeydown($event, minuteInput)"
						role="spinbutton"
						[attr.aria-valuemin]="0"
						[attr.aria-valuemax]="59"
						[attr.aria-valuenow]="value.minute | addLeadingZero"
						[attr.aria-label]="localization.selectMinute"
					/>
				</div>
				<span
					class="fa-solid fa-angle-down agpr-timePicker-time-panel-icon"
					[class.agpr-timePicker-time-panel-icon--disabled]="isDecrementDisabled(timeUnits.minutes)"
					[attr.aria-disabled]="isDecrementDisabled(timeUnits.minutes)"
					(click)="decrement(timeUnits.minutes)"
				></span>
			</label>
			<div
				aria-hidden="true"
				class="agpr-timePicker-numberInputSeparator"
				*ngIf="showSecond">
				:
			</div>
			<label class="agpr-timePicker-time-panel-input" *ngIf="showSecond">
				<span class="u-srOnly">
					{{ localization.selectSecond }}
				</span>
				<span
					class="fa-solid fa-angle-up agpr-timePicker-time-panel-icon"
					(click)="increment(timeUnits.seconds)"
				></span>
				<div class="agpr-timePicker-time-panel-value" [ngClass]="{'activeUnit': activeTimeUnit === timeUnits.seconds}">
					<input
						*ngIf="value && showSecond"
						autocomplete="off"
						readonly
						type="text"
						placeholder="--"
						[id]="id + '.timePicker.panel.secondInput'"
						[attr.aria-describedby]="secondDescribedBy"
						[disabled]="disabled"
						[ngModel]="value.second | addLeadingZero"
						(wheel)="scrollSecond($event)"
						(focus)="setActiveTimeUnit(timeUnits.seconds)"
						(keydown)="inputKeydown($event, secondInput)"
						role="spinbutton"
						[attr.aria-valuemin]="0"
						[attr.aria-valuemax]="59"
						[attr.aria-valuenow]="value.second | addLeadingZero"
						[attr.aria-label]="localization.selectSecond"
					/>
				</div>
				<span
					class="fa-solid fa-angle-down agpr-timePicker-time-panel-icon"
					(click)="decrement(timeUnits.seconds)"
				></span>
			</label>
			<label
				*ngIf="value && value.format === timeFormats.twelveHour && !durationMode"
				class="agpr-timePicker-meridianSelector agpr-timePicker-time-panel-input"
			>
				<span class="u-srOnly">
					{{ localization.selectMeridian }}
				</span>
				<span
					class="fa-solid fa-angle-up"
					[class.agpr-timePicker-time-panel-icon--disabled]="isMeridianToggleDisabled()"
					[attr.aria-disabled]="isMeridianToggleDisabled()"
					(click)="toggleMeridian()"
				></span>
				<div class="agpr-timePicker-time-panel-value" [ngClass]="{'activeUnit': activeTimeUnit === null}">
					<input
						autocomplete="off"
						readonly
						type="text"
						[id]="id + '.timePicker.panel.meridianInput'"
						[disabled]="disabled"
						[ngModel]="value.meridian"
						(keydown)="inputKeydown($event, meridianInput)"
						(focus)="setActiveTimeUnit(null)"
						[attr.aria-valuenow]="value.meridian"
						[attr.aria-label]="localization.selectMeridian"
					/>
				</div>
				<span
					class="fa-solid fa-angle-down"
					[class.agpr-timePicker-time-panel-icon--disabled]="isMeridianToggleDisabled()"
					[attr.aria-disabled]="isMeridianToggleDisabled()"
					(click)="toggleMeridian()"
				></span>
			</label>
		</fieldset>
	</div>
	<div *ngIf="showTimeZoneSelector && !durationMode && value" class="agpr-timePicker-timeZone ui-fluid">
		<agpr-timezone-picker
			class='agpr-timePicker-timeZoneDropdown'
			[id]="id + '.timezonePicker'"
			[(ngModel)]="value.timeZone"
			(ngModelChange)="timeZoneChanged()"
			[disabled]="disabled"
			*ngIf="!durationMode"
		></agpr-timezone-picker>
		<span
			*ngIf="showTimezoneDisclaimer"
			role="img"
			class="fa-regular fa-circle-info"
			[ngClass]="infoIconStyleClass"
			[tooltipStyleClass]="infoTooltipStyleClass"
			agprTooltip="Common.forms.timePicker.daylightSavingsDisclaimer"
		>
		</span>
	</div>
</section>
